var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyPrediction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 39,
    viewBox: "0 0 52 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M49.0046 2.90874C29.921 0.461166 10.3566 1.88876 2.40518 2.90858C0.629964 19.5521 1.66558 32.2797 2.40525 37.1748C21.9326 39.6223 41.7928 37.5827 49.5593 36.5629C52.2221 20.4089 50.1141 8.00782 49.0046 2.90874Z",
    fill: "#EEEEE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.2517 38.8221C18.3367 38.822 10.4269 38.3845 2.55366 37.5114L2.01807 37.4531L1.93568 36.8817C0.307249 25.578 0.307249 14.0719 1.93568 2.7682L2.01807 2.19681L2.55366 2.1385C18.3106 0.391659 34.1928 0.391659 49.9498 2.1385L50.4832 2.19681L50.5656 2.7682C52.1925 14.0509 52.1925 25.536 50.5656 36.8187L50.4745 37.4601L49.9389 37.5184C42.0691 38.3887 34.163 38.8239 26.2517 38.8221ZM3.23236 36.0794C18.5391 37.7376 33.9621 37.7376 49.2689 36.0794C50.7726 25.3034 50.7726 14.3464 49.2689 3.57048C33.9614 1.91227 18.5377 1.91227 3.23019 3.57048C1.73039 14.3468 1.73112 25.3033 3.23236 36.0794Z",
    fill: "url(#paint0_linear_687_53642)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_687_53642",
    x1: 51.7858,
    y1: 38.8221,
    x2: 12.4758,
    y2: -8.86664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPrediction);
export default __webpack_public_path__ + "static/media/emptyPrediction.4c0e9e86082cc8f6caf782ab046384af.svg";
export { ForwardRef as ReactComponent };